import { getLayoutByName } from "../registy";
import { GridLayout } from "./grid";
import { RandomLayout } from "./random";
import { GForceLayout } from "./gForce";
import { ForceLayout } from "./force";
import { CircularLayout } from "./circular";
import { DagreLayout } from "./dagre";
import { RadialLayout } from "./radial";
import { ConcentricLayout } from "./concentric";
import { MDSLayout } from "./mds";
import { FruchtermanLayout } from "./fruchterman";
import { FruchtermanGPULayout } from "./gpu/fruchterman";
import { GForceGPULayout } from "./gpu/gForce";
import { ComboForceLayout } from "./comboForce";
import { ForceAtlas2Layout } from "./forceAtlas2";
import { ERLayout } from "./er";
export class Layout {
    constructor(options) {
        const layoutClass = getLayoutByName(options.type);
        this.layoutInstance = new layoutClass(options);
    }
    layout(data) {
        return this.layoutInstance.layout(data);
    }
    updateCfg(cfg) {
        this.layoutInstance.updateCfg(cfg);
    }
    init(data) {
        this.layoutInstance.init(data);
    }
    execute() {
        this.layoutInstance.execute();
    }
    getDefaultCfg() {
        return this.layoutInstance.getDefaultCfg();
    }
    destroy() {
        return this.layoutInstance.destroy();
    }
}
// FIXME
// FOR G6
// tslint:disable-next-line
export const Layouts = {
    force: ForceLayout,
    fruchterman: FruchtermanLayout,
    forceAtlas2: ForceAtlas2Layout,
    gForce: GForceLayout,
    dagre: DagreLayout,
    circular: CircularLayout,
    radial: RadialLayout,
    concentric: ConcentricLayout,
    grid: GridLayout,
    mds: MDSLayout,
    comboForce: ComboForceLayout,
    random: RandomLayout,
    'gForce-gpu': GForceGPULayout,
    'fruchterman-gpu': FruchtermanGPULayout,
    er: ERLayout,
};
//# sourceMappingURL=layout.js.map